.l{justify-content:center;}